import React from 'react'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJs,CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend } from 'chart.js'  
ChartJs.register(
    CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip)
export const Graph = ({graphdata}) => {
  return (
    <div>
        <Line data={
            {
                labels:graphdata.map((i)=>{
                    return i[0] }),
                datasets:[
                    {
                        data:graphdata.map(i=>i[1]),
                         
                        label:'wpm',
                        borderColor:'gold'
                    }
                ]
            }
        }/>
    </div>
  )
}
